import { addToRecord, arrayWithoutSubset } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { TypingIndicatorsBegan, TypingIndicatorsFinished } from '../../domains/typingIndicators/actions.types';

import { TypingIndicators } from './types';

const initialState = {};

export type TypingIndicatorsAction = TypingIndicatorsBegan | TypingIndicatorsFinished;

const addUserToTypers = (state: TypingIndicators, payload: TypingIndicatorsBegan['payload']) => {
  const { userId, threadId } = payload;
  const currentTypers = state[threadId] || [];

  const isUserAlreadyTyping = currentTypers.indexOf(userId) > -1;
  if (isUserAlreadyTyping) {
    return state;
  }

  const typersWithUser = [...currentTypers, userId];

  return addToRecord(state, threadId, typersWithUser);
};

const removeUsersFromTypers = (state: TypingIndicators, payload: TypingIndicatorsFinished['payload']) => {
  const { userIds, threadId } = payload;
  const currentTypers = state[threadId];

  if (!currentTypers) {
    return state;
  }

  const typersWithoutUser = arrayWithoutSubset(currentTypers, userIds);

  return addToRecord(state, threadId, typersWithoutUser);
};

const reducer: Reducer<TypingIndicators, TypingIndicatorsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TYPING_INDICATORS.TYPING_BEGAN': {
      return addUserToTypers(state, action.payload);
    }
    case 'TYPING_INDICATORS.TYPING_FINISHED': {
      return removeUsersFromTypers(state, action.payload);
    }
    default:
      return state;
  }
};

export default reducer;
